<template>
  <vue-good-table
      styleClass="vgt-table table table-stat vgt-table-odd-even"
      ref="vgt"
      :columns="filteredColumns"
      :rows="rows"
      :pagination-options="{
        enabled: rows.length > 25,
        perPage: 25,
        perPageDropdown: [25, 50, 100],
        rowsPerPageLabel: 'Строк на странице',
        allLabel: 'Все',
        ofLabel: 'из',
        prevLabel: 'Назад',
        nextLabel: 'Вперед',
      }"
      compactMode
  >
    <template slot="table-column" slot-scope="props">
      <span v-if="props.column.tooltip" class="column-tooltip" :title="props.column.tooltip">{{ props.column.label }}</span>
      <span v-else>{{ props.column.label }}</span>
    </template>
    <div slot="table-actions" v-if="exports">
      <button class="btn btn-blue" @click="exportToCSV">Export CSV</button>
    </div>
  </vue-good-table>
</template>

<script>
export default {
  name: 'TableV1',
  props: {
    columns: {},
    rows: {},
    exports: {},
    exportsFilename: {},
  },
  computed: {
    filteredColumns() {
      // No rows yet, show all columns without conditions.
      if (this.rows.length === 0) {
        return this.columns.filter(columnOptions => !columnOptions.showWhen);
      }
      const firstRow = this.rows[0];
      return this.columns.filter(columnOptions => {
        // No condition, always show column.
        if (!columnOptions.showWhen) {
          return true;
        }
        // Check if column should be shown.
        return columnOptions.showWhen(firstRow);
      });
    },
  },
  methods: {
    getFilename() {
      const name = this.exportsFilename ? this.exportsFilename() : 'fh_stats';
      return `${name}.csv`;
    },

    /**
     * Main function to export CSV:
     * 1. Retrieves the processed rows and visible columns.
     * 2. Prepares the CSV data as an array of arrays (without joining cell values to strings).
     * 3. Passes the prepared data and filename to the download function.
     */
    exportToCSV() {
      console.log('Export CSV initiated.');

      const processedRows = this.getProcessedRows();
      const visibleColumns = this.getVisibleColumns();

      console.log('processedRows', processedRows);
      console.log('visibleColumns', visibleColumns);

      // Prepare CSV data as an array of arrays.
      // The first element is the header (an array of column names)
      // and subsequent elements are arrays of row cell values.
      const csvDataArray = this.prepareCSVData(visibleColumns, processedRows);
      console.log('Prepared CSV Data Array:', csvDataArray);

      // Pass the prepared data to the download function.
      this.downloadCSVFile(csvDataArray, this.getFilename());
      console.log('CSV download triggered.');
    },

    /**
     * Retrieves the processed (filtered and sorted) rows from the table.
     */
    getProcessedRows() {
      return this.$refs.vgt.processedRows[0].children; // Rows used for rendering a table (applied sorting).
    },

    /**
     * Retrieves the visible columns in their current order.
     */
    getVisibleColumns() {
      return this.filteredColumns.filter(col => !col.hidden);
    },

    /**
     * Prepares the CSV data as an array of arrays.
     * Each inner array represents a row of cells.
     * The header row (first element) is an array of column names.
     *
     * @param {Array} visibleColumns - Array of visible column objects.
     * @param {Array} rows - Array of processed row objects.
     * @returns {Array} - Array of arrays (header row and data rows).
     */
    prepareCSVData(visibleColumns, rows) {
      // Build header row without joining with commas.
      const headerRow = visibleColumns.map(col => col.label);

      // Build each data row as an array of cell strings.
      const dataRows = rows.map(row => {
        return visibleColumns.map(col => {
          let cell = row[col.field] != null ? row[col.field].toString() : '';
          // Escape double quotes.
          cell = cell.replace(/"/g, '""');
          // Wrap cell in quotes if it contains special characters.
          if (cell.search(/("|,|\n)/g) >= 0) {
            cell = `"${cell}"`;
          }
          return cell;
        });
      });

      return [headerRow, ...dataRows];
    },

    /**
     * Converts the prepared CSV data (an array of arrays) into a CSV file and triggers its download.
     *
     * @param {Array} csvDataArray - Array of arrays (each inner array represents a row).
     * @param {String} filename - The name for the downloaded CSV file.
     */
    downloadCSVFile(csvDataArray, filename) {
      // Convert each row array into a CSV-formatted string by joining cells with commas,
      // then join all row strings with newlines.
      const csvContent = csvDataArray.map(row => row.join(',')).join('\n');

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
};
</script>
